import textUtils from '@powerednow/shared/modules/utilities/textUtils';

const stopwordsEn = [
    'a', 'an', 'and', 'are', 'as', 'at', 'be', 'but', 'by', 'for', 'if',
    'in', 'into', 'is', 'it', 'no', 'not', 'of', 'on', 'or', 'such', 'that',
    'the', 'their', 'then', 'there', 'these', 'they', 'this', 'to', 'was', 'will', 'with',
];

export function nGram(input: string, n = 3, prefixMarkerChar = '^') {
    let preprocessedInput = input;
    if (textUtils.isUKPostcode(input)) {
        preprocessedInput = input.replaceAll(' ', '');
    }
    const filteredWords = preprocessedInput.split(' ').map(text => text.replaceAll(/<\/?[^<]*>/g, '').toLowerCase()).filter(word => !stopwordsEn.includes(word) && word.length);
    const nGramSet = new Set();
    filteredWords.forEach(word => {
        let prefixMarker = prefixMarkerChar;
        if (word.length <= n) {
            nGramSet.add(`${prefixMarker}${word}`);
        } else {
            for (let index = 0; index + n <= word.length; index += 1) {
                nGramSet.add(`${prefixMarker}${word.slice(index, index + n)}`);
                prefixMarker = '';
            }
        }
    });
    return Array.from(nGramSet);
}

export function jsonNGram(inputObj: { [key: string]: any}, searchMap?: {[key:string]: any}, n = 3, prefixMarkerChar = '^') {
    const fieldNgrams = [];
    const objectKeys = [];
    Object.keys(inputObj).forEach(valueKey => {
        const value = inputObj[valueKey];
        const searchMapValue = searchMap === undefined || searchMap[valueKey];
        if (searchMapValue && typeof value === 'string' && value !== '') {
            const rawNgrams = nGram(value, n, prefixMarkerChar);
            fieldNgrams.push(...rawNgrams.map(ngramString => `${valueKey}|${ngramString}`));
            objectKeys.push(valueKey);
        }
        if (searchMapValue && value !== null && typeof value === 'object') {
            const subSearchMap = typeof searchMapValue === 'boolean' ? undefined : searchMapValue;
            const { fieldNgrams: subNgrams, objectKeys: subKeys } = jsonNGram(value, subSearchMap, n, prefixMarkerChar);
            fieldNgrams.push(...subNgrams.map(ngramString => `${valueKey}.${ngramString}`));
            objectKeys.push(...subKeys.map(key => `${valueKey}.${key}`));
        }
    });
    return { fieldNgrams, objectKeys };
}
